module.exports = __webpack_public_path__ + "media/images/logos/windeurope-annual3000-4b193431ecc8c44554ef65f2ab102879.svg";